import React from 'react'
import { Grid } from '@material-ui/core'
import MainTemplate from '../../templates/MainTemplate'
import DailyMonitoringTemplate from '../../templates/DailyMonitoringTemplate'
import DateInfo from '../../containers/dailyMonitoring/details/main/DateInfo'
import CancelledSummary from '../../containers/dailyMonitoring/details/cancelled/CancelledSummary'
import DailyTotals from '../../containers/dailyMonitoring/details/cancelled/DailyTotals/Index'

const DailyMonitoringCancelled = (): JSX.Element => {
  return (
    <MainTemplate>
      <DailyMonitoringTemplate>
        <Grid item xs={12}>
          <DateInfo />
        </Grid>
        <Grid item xs={12}>
          <CancelledSummary />
        </Grid>
        <Grid item xs={12}>
          <DailyTotals />
        </Grid>
      </DailyMonitoringTemplate>
    </MainTemplate>
  )
}

export default DailyMonitoringCancelled
